import { Modal } from '@mantine/core';

interface ImageLightboxProps {
  opened: boolean;
  onClose: () => void;
  imageUrl: string;
  fileName: string;
}

export function ImageLightbox({
  opened,
  onClose,
  imageUrl,
  fileName,
}: ImageLightboxProps) {
  return (
    <Modal opened={opened} onClose={onClose} size="xl" centered fullScreen>
      <img
        src={imageUrl}
        alt={fileName}
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          maxHeight: 'calc(100vh - 100px)',
          objectFit: 'contain',
        }}
      />
    </Modal>
  );
}
